export function isBot(): boolean {
  if (typeof navigator === 'undefined') return true;
  const botPattern = /bot|googlebot|crawler|spider|robot|crawling/i;
  return botPattern.test(navigator.userAgent) || !!navigator.webdriver;
}
